import React from 'react';

function SlideThreeCard(props) {
    
    const { strTeam,strTeamBadge, intFormedYear,strStadium,strStadiumLocation,intStadiumCapacity,strTeamJersey,strTeamShort } = props;

    return (
        <div className="allCard">
            <div className='teamImage'>
                <img className='teamJersey' src={strTeamJersey} alt={strTeamBadge}/>
            </div>
            <div className='info'>
                <div className='teamHeader'>
                    <h1>{strTeam}</h1>
                    <img className='teamBagde' src={strTeamBadge} alt={`${strTeam}`} />
                </div>
                <div className='teamInfo'>
                    <ul>
                        <li> Team Short Name: {strTeamShort}</li>
                        <li> Formed year: {intFormedYear}</li>
                        <li>Stadium: {strStadium}</li>
                        <li>Stadium location: {strStadiumLocation}</li>
                        <li>Stadium capacity: {intStadiumCapacity} seats</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default SlideThreeCard